import { CittadinoDTO } from "./cittadinoDTO";
import { ImpresaDTO } from "./impresaDTO";
import { AssociazioneDTO } from "./associazioneDTO";
import { UfficioDTO } from "../protocollo/ufficioDTO";
import { SoggettoStranieroDTO } from "./soggetto-stranieroDTO";
import { AmministrazioneDTO } from "./amministrazioneDTO";
import { AmministrazioneNonIpaDTO } from "./amministrazione-non-ipaDTO";
import { AooDTO } from "./aooDTO";

export class RicercaSoggettoDTO {
  cittadino: CittadinoDTO;

  impresa: ImpresaDTO;

  associazione: AssociazioneDTO;

  soggettoStraniero: SoggettoStranieroDTO;

  amministrazione: AmministrazioneDTO;

  amministrazioneNonIpa: AmministrazioneNonIpaDTO;

  aoo: AooDTO;

  ufficio: UfficioDTO;
}
